import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-long-arrow",
  "use": "app-icon-long-arrow-usage",
  "viewBox": "0 0 149 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 149 14\" id=\"app-icon-long-arrow\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M1 7.4h137.72\" stroke=\"#B8B8B8\" fill=\"#D8D8D8\" stroke-linecap=\"square\" /><path d=\"M148.626 7.666l-9.099 6.066a.5.5 0 01-.777-.416V1.184a.5.5 0 01.777-.416l9.099 6.066a.5.5 0 010 .832z\" fill=\"#B8B8B8\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol